import {
  OnboardingLoginForm,
  CreatePortalForm,
  CompanyProfileForm,
} from 'src/legacy/components/Onboarding/OnboardingForms';
import * as Constants from 'src/constants';

export enum OnboardingSteps {
  Start = 1,
  SignUp = 2,
  GoToPortal = 3,
}

export const baseOnboardingStepsData = [
  {
    step: OnboardingSteps.Start,
    title: 'Start your 14-day Copilot trial',
    subtitle: 'Setup takes 2 minutes and no credit card is required.',
    OnboardingComponent: OnboardingLoginForm,
    componentProps: {
      buttonLabel: 'Create free account',
      buttonHint: '',
    },
    trackEventName: Constants.OnboardingTrackEventName.Lead,
  },
  {
    step: OnboardingSteps.SignUp,
    title: 'Create your Copilot account',
    subtitle:
      'Tell us a bit about yourself and set the domain where your clients can access your portal.',
    OnboardingComponent: CreatePortalForm,
    delay: 4000,
    componentProps: {
      buttonLabel: 'Create workspace',
      buttonHint: '',
    },
    trackEventName: Constants.OnboardingTrackEventName.CompleteRegistration,
  },
  {
    step: OnboardingSteps.GoToPortal,
    title: 'Tell us more about your company',
    subtitle: `This information lets us customize your experience.`,
    OnboardingComponent: CompanyProfileForm,
    delay: 4000,
    componentProps: {
      buttonLabel: Constants.ONBOARDING_LAST_STEP_BUTTON_LABEL,
      buttonHint: '',
    },
    trackEventName: Constants.OnboardingTrackEventName.StartTrial,
  },
];

export const getOnboardingStepsData = () => baseOnboardingStepsData;
